/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * Сервис Интранет — API
 * API внутреннего корпоративного портала
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  MarkReadDto,
  NotificationCountDto,
  NotificationListDto,
  NotificationsControllerListV1Params,
  PushKeyDto,
  PushSubscribeDto,
  PushUnsubscribeDto
} from '../models';

import { apiRequest } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type notificationsControllerPushKeyV1Response200 = {
  data: PushKeyDto
  status: 200
}

export type notificationsControllerPushKeyV1ResponseSuccess = (notificationsControllerPushKeyV1Response200) & {
  headers: Headers;
};
;

export type notificationsControllerPushKeyV1Response = (notificationsControllerPushKeyV1ResponseSuccess)

export const getNotificationsControllerPushKeyV1Url = () => {




  return `/api/v1/notifications/push/key`
}

/**
 * @summary Публичный ключ для подписки устройства на пуш-уведомления
 */
export const notificationsControllerPushKeyV1 = async ( options?: RequestInit): Promise<notificationsControllerPushKeyV1Response> => {

  return apiRequest<notificationsControllerPushKeyV1Response>(getNotificationsControllerPushKeyV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getNotificationsControllerPushKeyV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerPushKeyV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerPushKeyV1>>, TError,void, TContext> => {

const mutationKey = ['notificationsControllerPushKeyV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsControllerPushKeyV1>>, void> = () => {


          return  notificationsControllerPushKeyV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsControllerPushKeyV1MutationResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerPushKeyV1>>>

    export type NotificationsControllerPushKeyV1MutationError = unknown

    /**
 * @summary Публичный ключ для подписки устройства на пуш-уведомления
 */
export const useNotificationsControllerPushKeyV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerPushKeyV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof notificationsControllerPushKeyV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getNotificationsControllerPushKeyV1MutationOptions(options), queryClient);
    }
    export type notificationsControllerPushSubscribeV1Response204 = {
  data: void
  status: 204
}

export type notificationsControllerPushSubscribeV1ResponseSuccess = (notificationsControllerPushSubscribeV1Response204) & {
  headers: Headers;
};
;

export type notificationsControllerPushSubscribeV1Response = (notificationsControllerPushSubscribeV1ResponseSuccess)

export const getNotificationsControllerPushSubscribeV1Url = () => {




  return `/api/v1/notifications/push/subscribe`
}

/**
 * @summary Подписать это устройство на пуш-уведомления
 */
export const notificationsControllerPushSubscribeV1 = async (pushSubscribeDto: PushSubscribeDto, options?: RequestInit): Promise<notificationsControllerPushSubscribeV1Response> => {

  return apiRequest<notificationsControllerPushSubscribeV1Response>(getNotificationsControllerPushSubscribeV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pushSubscribeDto)
  }
);}





export const getNotificationsControllerPushSubscribeV1QueryKey = (pushSubscribeDto?: MaybeRef<PushSubscribeDto>,) => {
    return [
    'POST', 'api','v1','notifications','push','subscribe', pushSubscribeDto
    ] as const;
    }


export const getNotificationsControllerPushSubscribeV1QueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerPushSubscribeV1>>, TError = unknown>(pushSubscribeDto: MaybeRef<PushSubscribeDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerPushSubscribeV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getNotificationsControllerPushSubscribeV1QueryKey(pushSubscribeDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerPushSubscribeV1>>> = ({ signal }) => notificationsControllerPushSubscribeV1(unref(pushSubscribeDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerPushSubscribeV1>>, TError, TData>
}

export type NotificationsControllerPushSubscribeV1QueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerPushSubscribeV1>>>
export type NotificationsControllerPushSubscribeV1QueryError = unknown


/**
 * @summary Подписать это устройство на пуш-уведомления
 */

export function useNotificationsControllerPushSubscribeV1<TData = Awaited<ReturnType<typeof notificationsControllerPushSubscribeV1>>, TError = unknown>(
 pushSubscribeDto: MaybeRef<PushSubscribeDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerPushSubscribeV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerPushSubscribeV1QueryOptions(pushSubscribeDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type notificationsControllerPushUnsubscribeV1Response204 = {
  data: void
  status: 204
}

export type notificationsControllerPushUnsubscribeV1ResponseSuccess = (notificationsControllerPushUnsubscribeV1Response204) & {
  headers: Headers;
};
;

export type notificationsControllerPushUnsubscribeV1Response = (notificationsControllerPushUnsubscribeV1ResponseSuccess)

export const getNotificationsControllerPushUnsubscribeV1Url = () => {




  return `/api/v1/notifications/push/unsubscribe`
}

/**
 * @summary Отписать это устройство (выход, выключение уведомлений)
 */
export const notificationsControllerPushUnsubscribeV1 = async (pushUnsubscribeDto: PushUnsubscribeDto, options?: RequestInit): Promise<notificationsControllerPushUnsubscribeV1Response> => {

  return apiRequest<notificationsControllerPushUnsubscribeV1Response>(getNotificationsControllerPushUnsubscribeV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pushUnsubscribeDto)
  }
);}





export const getNotificationsControllerPushUnsubscribeV1QueryKey = (pushUnsubscribeDto?: MaybeRef<PushUnsubscribeDto>,) => {
    return [
    'POST', 'api','v1','notifications','push','unsubscribe', pushUnsubscribeDto
    ] as const;
    }


export const getNotificationsControllerPushUnsubscribeV1QueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerPushUnsubscribeV1>>, TError = unknown>(pushUnsubscribeDto: MaybeRef<PushUnsubscribeDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerPushUnsubscribeV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getNotificationsControllerPushUnsubscribeV1QueryKey(pushUnsubscribeDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerPushUnsubscribeV1>>> = ({ signal }) => notificationsControllerPushUnsubscribeV1(unref(pushUnsubscribeDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerPushUnsubscribeV1>>, TError, TData>
}

export type NotificationsControllerPushUnsubscribeV1QueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerPushUnsubscribeV1>>>
export type NotificationsControllerPushUnsubscribeV1QueryError = unknown


/**
 * @summary Отписать это устройство (выход, выключение уведомлений)
 */

export function useNotificationsControllerPushUnsubscribeV1<TData = Awaited<ReturnType<typeof notificationsControllerPushUnsubscribeV1>>, TError = unknown>(
 pushUnsubscribeDto: MaybeRef<PushUnsubscribeDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerPushUnsubscribeV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerPushUnsubscribeV1QueryOptions(pushUnsubscribeDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export type notificationsControllerListV1Response200 = {
  data: NotificationListDto
  status: 200
}

export type notificationsControllerListV1ResponseSuccess = (notificationsControllerListV1Response200) & {
  headers: Headers;
};
;

export type notificationsControllerListV1Response = (notificationsControllerListV1ResponseSuccess)

export const getNotificationsControllerListV1Url = (params?: NotificationsControllerListV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/notifications?${stringifiedParams}` : `/api/v1/notifications`
}

/**
 * @summary Мои уведомления (новые сверху) и счётчик непрочитанных
 */
export const notificationsControllerListV1 = async (params?: NotificationsControllerListV1Params, options?: RequestInit): Promise<notificationsControllerListV1Response> => {

  return apiRequest<notificationsControllerListV1Response>(getNotificationsControllerListV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getNotificationsControllerListV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerListV1>>, TError,{params?: NotificationsControllerListV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerListV1>>, TError,{params?: NotificationsControllerListV1Params}, TContext> => {

const mutationKey = ['notificationsControllerListV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsControllerListV1>>, {params?: NotificationsControllerListV1Params}> = (props) => {
          const {params} = props ?? {};

          return  notificationsControllerListV1(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsControllerListV1MutationResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerListV1>>>

    export type NotificationsControllerListV1MutationError = unknown

    /**
 * @summary Мои уведомления (новые сверху) и счётчик непрочитанных
 */
export const useNotificationsControllerListV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerListV1>>, TError,{params?: NotificationsControllerListV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof notificationsControllerListV1>>,
        TError,
        {params?: NotificationsControllerListV1Params},
        TContext
      > => {
      return useMutation(getNotificationsControllerListV1MutationOptions(options), queryClient);
    }
    export type notificationsControllerUnreadCountV1Response200 = {
  data: NotificationCountDto
  status: 200
}

export type notificationsControllerUnreadCountV1ResponseSuccess = (notificationsControllerUnreadCountV1Response200) & {
  headers: Headers;
};
;

export type notificationsControllerUnreadCountV1Response = (notificationsControllerUnreadCountV1ResponseSuccess)

export const getNotificationsControllerUnreadCountV1Url = () => {




  return `/api/v1/notifications/unread-count`
}

/**
 * @summary Сколько непрочитанных — для значка колокольчика
 */
export const notificationsControllerUnreadCountV1 = async ( options?: RequestInit): Promise<notificationsControllerUnreadCountV1Response> => {

  return apiRequest<notificationsControllerUnreadCountV1Response>(getNotificationsControllerUnreadCountV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getNotificationsControllerUnreadCountV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>, TError,void, TContext> => {

const mutationKey = ['notificationsControllerUnreadCountV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>, void> = () => {


          return  notificationsControllerUnreadCountV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotificationsControllerUnreadCountV1MutationResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>>

    export type NotificationsControllerUnreadCountV1MutationError = unknown

    /**
 * @summary Сколько непрочитанных — для значка колокольчика
 */
export const useNotificationsControllerUnreadCountV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof notificationsControllerUnreadCountV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getNotificationsControllerUnreadCountV1MutationOptions(options), queryClient);
    }
    export type notificationsControllerMarkReadV1Response200 = {
  data: NotificationCountDto
  status: 200
}

export type notificationsControllerMarkReadV1ResponseSuccess = (notificationsControllerMarkReadV1Response200) & {
  headers: Headers;
};
;

export type notificationsControllerMarkReadV1Response = (notificationsControllerMarkReadV1ResponseSuccess)

export const getNotificationsControllerMarkReadV1Url = () => {




  return `/api/v1/notifications/read`
}

/**
 * @summary Отметить прочитанными: выбранные или все
 */
export const notificationsControllerMarkReadV1 = async (markReadDto: MarkReadDto, options?: RequestInit): Promise<notificationsControllerMarkReadV1Response> => {

  return apiRequest<notificationsControllerMarkReadV1Response>(getNotificationsControllerMarkReadV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(markReadDto)
  }
);}





export const getNotificationsControllerMarkReadV1QueryKey = (markReadDto?: MaybeRef<MarkReadDto>,) => {
    return [
    'POST', 'api','v1','notifications','read', markReadDto
    ] as const;
    }


export const getNotificationsControllerMarkReadV1QueryOptions = <TData = Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>, TError = unknown>(markReadDto: MaybeRef<MarkReadDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getNotificationsControllerMarkReadV1QueryKey(markReadDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>> = ({ signal }) => notificationsControllerMarkReadV1(unref(markReadDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>, TError, TData>
}

export type NotificationsControllerMarkReadV1QueryResult = NonNullable<Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>>
export type NotificationsControllerMarkReadV1QueryError = unknown


/**
 * @summary Отметить прочитанными: выбранные или все
 */

export function useNotificationsControllerMarkReadV1<TData = Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>, TError = unknown>(
 markReadDto: MaybeRef<MarkReadDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsControllerMarkReadV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsControllerMarkReadV1QueryOptions(markReadDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






